import { LocalizedLicensePlate } from "types";
import starsCircleEU from "img/stars-circle-eu.svg";


// for EU countries having only 1 letter as country shortcode in their license plate
export const getLicensePlateCountryLetters = (countryCode: string): string => {
    switch (countryCode) {
        case 'BE':
            return 'B';
        case 'DE':
            return 'D';
        case 'FR':
            return 'F';
        case 'LU':
            return 'L';
        case 'AT':
            return 'A';
        default:
            return countryCode
    }
}


// FUTURE IMPLEMENTATION 
// waiting for: https://concar.atlassian.net/browse/PD-5807

export const LocalisedLicensePlate = ({ llp }: { llp?: LocalizedLicensePlate }) => {
    return llp && (
        <div className={`llp cc-${llp.countryCode}`}>
            <span className="llp-cc countryLettersBox">
                <img className="icon-stars-circle-eu" src={starsCircleEU} alt="eu flag" />
                <span className="lp-letters">{getLicensePlateCountryLetters(llp.countryCode)}</span>
            </span>
            <span className="llp-lp">{llp.licensePlate}</span>
        </div>
    )
}

export const LicensePlate = ({ llp }: { llp?: LocalizedLicensePlate }) => {
    return (
        <span>{llp?.licensePlate}</span>
    )
}
